import React from 'react';
import Header from './Header';

const NotFound = ({error, onRetry }) => (
<div className="transcribed-consultation-form">
    <Header />
    <div className="mt-0 container">
      <div className="row justify-content-md-center g-3">
        <div className="col-12">
          <div className="w-form fade-in">
            <div className="row g-5">
              <div className="col-12 text-center">
                <div className="alert alert-danger" role="alert">
                  <h4 className="alert-heading">Error Loading Form</h4>
                  <p>{error}</p>
                  <hr />
                  <button 
                    className="btncust activebg"
                    onClick={onRetry}
                  >
                    Try Again
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
);

export default NotFound;